import React from "react";
import classes from "../layout/loader.module.css";

const Loader = () => {
  return <div id="loader" className={classes.loader}></div>;
};

export default Loader;
